/**
 * Jeux d'images responsives (srcset) pour les visuels lourds du site.
 * Les variantes sont générées et hébergées sur le CDN.
 */
import hero480 from "@/assets/hero-mariage-dj-480-v2.webp.asset.json";
import hero640 from "@/assets/hero-mariage-dj-640-v2.webp.asset.json";
import hero960 from "@/assets/hero-mariage-dj-960-v2.webp.asset.json";
import hero1280 from "@/assets/hero-mariage-dj-1280-v2.webp.asset.json";
import hero480Avif from "@/assets/hero-mariage-dj-480-v2.avif.asset.json";
import hero640Avif from "@/assets/hero-mariage-dj-640-v2.avif.asset.json";
import hero960Avif from "@/assets/hero-mariage-dj-960-v2.avif.asset.json";
import hero1280Avif from "@/assets/hero-mariage-dj-1280-v2.avif.asset.json";
import mariage400 from "@/assets/mariage-janine-richard-saint-remy-400.webp.asset.json";
import mariage640 from "@/assets/mariage-janine-richard-saint-remy-640.webp.asset.json";
import mariage800 from "@/assets/mariage-janine-richard-saint-remy-800.webp.asset.json";
import setup480 from "@/assets/notre-set-up-480.webp.asset.json";
import setup800 from "@/assets/notre-set-up-800.webp.asset.json";
import setup1200 from "@/assets/notre-set-up-1200.webp.asset.json";

export const HERO_HOME = {
  src: hero1280.url,
  avifSrc: hero1280Avif.url,
  srcSet: `${hero480.url} 480w, ${hero640.url} 640w, ${hero960.url} 960w, ${hero1280.url} 1280w`,
  avifSrcSet: `${hero480Avif.url} 480w, ${hero640Avif.url} 640w, ${hero960Avif.url} 960w, ${hero1280Avif.url} 1280w`,
  sizes: "100vw",
  width: 1280,
  height: 661,
};


export const MARIAGE_PHOTO = {
  src: mariage640.url,
  srcSet: `${mariage400.url} 400w, ${mariage640.url} 640w, ${mariage800.url} 800w`,
  sizes: "(max-width: 768px) 100vw, 33vw",
  width: 640,
  height: 853,
};

export const SETUP_PHOTO = {
  src: setup800.url,
  srcSet: `${setup480.url} 480w, ${setup800.url} 800w, ${setup1200.url} 1200w`,
  sizes: "(max-width: 768px) 100vw, 50vw",
  width: 800,
  height: 1062,
};
